<template>
  <section class="entry-layout" style="height:100vh;min-width:1200px;">
    <entry-layout-header
      :menus="menus"
      :customTabs="customTabs"
      :customMenus="customMenus"
      :menusActiveID="menusActiveID"
      :currentLang="currentLang"
      :subjectMode="subjectMode"
      @menusadd="handleAddCustomMenus"
      @menuschange="handleMenusChange"
      @menuchange="handleMenuChange"
      @custommenu="handleEditCustomMenus"
    >
      <slot name="rightContentRender" slot="rightContentRender"></slot>
    </entry-layout-header>
    <section class="entry-layout entry-layout--has-sider">
      <entry-sider
        :menus="menus"
        :customMenus="customMenus"
        :menusActiveID="menusActiveID"
        :panesHistory="panesHistory"
        :currentLang="currentLang"
        @menusadd="handleAddCustomMenus"
        @menusremove="handleRemoveCustomMenus"
        @menuschange="handleMenusChange"
        @menuchange="handleMenuChange"
        @menupushpin="handleMenuPushpin"
      />
      <section class="entry-layout">
        <entry-multi-tab
          :panes="panes"
          :activeKey="activeKey"
          :currentLang="currentLang"
          @change="handleMenuChange"
        />
        <!-- 跑马灯 -->
        <ticker class="entry-ticker-bar"></ticker>
        <!-- 主体 -->
        <entry-layout-content>
          <slot></slot>
        </entry-layout-content>
      </section>
    </section>
  </section>
</template>

<script>
import EntryLayoutHeader from './EntryLayoutHeader'
import EntryLayoutContent from './EntryLayoutContent'
import EntrySider from './EntrySider'
import EntryMultiTab from './EntryMultiTab'
import Ticker from '@/components/Tips/NewsTicker'

export default {
  name: 'EntryLayout',
  props: {
    subjectMode: {
      type: [Number, Object],
      default: () => null
    },
    menus: {
      type: Array,
      default: () => []
    },
    customMenus: {
      type: Array,
      default: () => []
    },
    customTabs: {
      type: [Array, Array],
      default: () => [[], []]
    },
    menusActiveID: {
      type: String,
      default: ''
    },
    panes: {
      type: Array,
      default: () => []
    },
    panesHistory: {
      type: Array,
      default: () => []
    },
    activeKey: {
      type: String,
      default: ''
    },
    currentLang: {
      type: String,
      default: 'zh_CN'
    }
  },
  components: {
    EntryLayoutHeader,
    EntryLayoutContent,
    EntrySider,
    EntryMultiTab,
    Ticker
  },
  methods: {
    // 新增自定义菜单
    handleAddCustomMenus () {
      if (this.$store.getters.isDemo) {
        this.$message.warning(this.$t('layouts.demo.tips'))
        return
      }
      this.$emit('addcustommenu')
    },
    // 删除自定义菜单
    handleRemoveCustomMenus (menu) {
      this.$emit('removecustommenu', menu)
    },
    // 修改自定义菜单
    handleEditCustomMenus (menu) {
      this.$emit('editcustommenu', menu)
    },
    // 显示菜单组
    handleMenusChange (key) {
      this.$emit('menuschange', key)
    },
    /**
     *  切换子菜单
     * @param[key] String - menuId
     * @param[record] Objecgt - { statisticsType, searchKey }
     */
    handleMenuChange (key, record = {}) {
      this.$emit('menuchange', { key, ...record })
    },
    // 钉一下，置顶菜单
    handleMenuPushpin (e) {
      this.$emit('menupushpin', e)
    }
  }
}
</script>

<style lang="less">
.entry-layout {
  flex: 1;
  display: flex;
  flex-direction: column;
  background: #f0f2f5;
  overflow: hidden;
}

.entry-layout.entry-layout--has-sider {
  flex-direction: row;
}
</style>
